import { Routes, Route } from "react-router-dom";
import InvoiceGroupTypes from "./InvoiceGroupTypes";
import InvoiceGroupTypeCreateEdit from "./InvoiceGroupTypeCreateEdit";

const index = () => {
	return (
		<Routes>
			<Route index element={<InvoiceGroupTypes />} />
			<Route path='/create' element={<InvoiceGroupTypeCreateEdit />} />
			<Route path='/:id/edit' element={<InvoiceGroupTypeCreateEdit />} />
		</Routes>
	);
};

export default index;
